import { MOCK_MIDTERM_MARKETS } from '@/features/midterm-map/mockMidtermMarkets'
import { groupRacesByState, toMidtermRace } from '@/features/midterm-map/midtermRaces'

/**
 * Production midterm snapshot, already in the bundle, used only to colour
 * the home banner's background map. The homepage does not fetch the tag —
 * live quotes stay on the Senate scoreboard and the /tags/midterm page.
 */
const races = MOCK_MIDTERM_MARKETS.map(market => toMidtermRace(market, 'OOM')).filter(Boolean)

export const BANNER_MAP_BY_STATE = groupRacesByState(races).byState
